import { RequestWaterSampling } from "../models/request/request-water-sampling/request-water-sampling";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { NotificationService } from "../../core/services/notification.service";
import { DataService } from "../../core/services/data.service";
import { Observable } from "rxjs";

@Injectable()
export class RequestWaterSamplingsService extends DataService<RequestWaterSampling, RequestWaterSampling> {
    constructor(
        protected http: HttpClient,
        protected notificationService: NotificationService) {
        super(http, notificationService);

        this.controllerName = 'request-water-samplings';
    }

    getByRequest(requestId: number): Observable<RequestWaterSampling> {
        return this.getQuery<RequestWaterSampling>(`${this.baseUrl()}/by-request/${requestId}`);
    }
}